import React from "react";

function Info() {
  return (
    <div>
      <h1>Info</h1>
      <p>OSMD player by ____</p>
      <p>OSMD adapted to React by Clardiza</p>
      <p>Music from Musescore</p>
    </div>
  );
}

export default Info;
